module.exports = __webpack_public_path__ + "static/media/Pyae-Soe-Aung.439c011f.png";